import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "data-table-empty-state" }
const _hoisted_2 = {
  width: "64",
  height: "41",
  viewBox: "0 0 64 41",
  xmlns: "http://www.w3.org/2000/svg",
  class: "data-table-empty-state__svg"
}
const _hoisted_3 = {
  key: 0,
  class: "data-table-empty-state__title"
}
const _hoisted_4 = {
  key: 1,
  class: "data-table-empty-state__description"
}
const _hoisted_5 = {
  key: 2,
  class: "data-table-empty-state__action"
}

import { computed } from "vue";

interface Props {
  title?: string;
  description?: string;
  message?: string;
  action?: any;
  showAction?: boolean;
  actionLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableEmptyState',
  props: {
    title: { default: "No data found" },
    description: { default: "There are no records to display at this time." },
    message: {},
    action: {},
    showAction: { type: Boolean },
    actionLabel: {}
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayMessage = computed(() => {
  return props.description || props.message || "There are no records to display at this time.";
});

const showActionButton = computed(() => {
  return props.showAction && props.actionLabel;
});

const handleAction = () => {
  emit("action");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("title", null, _toDisplayString(__props.title || "No data"), 1),
      _cache[0] || (_cache[0] = _createStaticVNode("<g transform=\"translate(0 1)\" fill=\"none\" fill-rule=\"evenodd\" data-v-39e87c92><ellipse fill=\"#f5f5f5\" cx=\"32\" cy=\"33\" rx=\"32\" ry=\"7\" data-v-39e87c92></ellipse><g fill-rule=\"nonzero\" stroke=\"#d9d9d9\" data-v-39e87c92><path d=\"M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z\" data-v-39e87c92></path><path d=\"M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z\" fill=\"#fafafa\" data-v-39e87c92></path></g></g>", 1))
    ])),
    (__props.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    (displayMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(displayMessage.value), 1))
      : _createCommentVNode("", true),
    (showActionButton.value || _ctx.$slots.action || __props.action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "action", {}, () => [
            (showActionButton.value && __props.actionLabel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "data-table-empty-state__action-button",
                  onClick: handleAction
                }, _toDisplayString(__props.actionLabel), 1))
              : (__props.action)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.action), { key: 1 }))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})